import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData from '../../gameData';
import GameButton from '../../ui/GameButton';
import Games from '../../Games';
import Game from '../Game';

export default class Title extends Phaser.Scene {
  static get KEY() { return 'Title'; } // do not change this if you override the scene

  constructor() {
    super({ key: Title.KEY });
  }

  create() {
    this.bg = ABCyaPhaser.Images.addImage(0,0, 'MainBackground_4x3', this).setOrigin(0);

    if (gameData.game === Games.alphabet) {
      this.title = ABCyaPhaser.Images.addImage(this.scale.width / 2, 0, 'TitleHeader', this, ABCyaPhaser.Images.LOCALIZATION_ATLAS);
      this.title.y = this.scale.height / 2 - 30;
    }
    else {
      this.logo = ABCyaPhaser.Images.addImage(this.scale.width / 2, 0, 'IntroLogo', this);
      this.logo.y = this.scale.height - this.logo.getBounds().height / 2 - 120;

      this.title = ABCyaPhaser.Images.addImage(this.scale.width / 2, 0, 'TitleHeader', this, ABCyaPhaser.Images.LOCALIZATION_ATLAS);
      this.title.y = this.logo.y - this.logo.getBounds().height / 2 - this.title.getBounds().height / 2 - 15;
    }

    this.btnGo = new GameButton(this, 45, 0x29b24b, ABCyaPhaser.Localization.instance.getLocalizedString('buttons.go'), 48);
    this.btnGo.x = this.scale.width / 2;
    this.btnGo.y = this.scale.height - this.btnGo.getBounds().height + 25;
    this.add.existing(this.btnGo);

    this.btnGo.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onClickGo, this);
  }

  onClickGo () {
    ABCyaPhaser.Audio.playOneShot('click', this);
    this.scene.start(Game.KEY);
  }
}